export default __webpack_public_path__ + "static/media/unl_logo.d93d14b9.png";